<template>
  <div class="documents-page">
    <h2>Dokumenty</h2>
    <div class="documents-grid">
      <div class="document-card" @click="openDocument('hracidoba.pdf')">
        <div class="document-icon">
          <i class="fas fa-image"></i>
        </div>
        <h3>Hrací doba</h3>
        <p>Pravidla hrací doby a časomíry</p>
      </div>

      <div class="document-card" @click="openDocument('trestnirad.pdf')">
        <div class="document-icon">
          <i class="fas fa-image"></i>
        </div>
        <h3>Trestní řád</h3>
        <p>Pravidla a postupy pro udělování trestů</p>
      </div>

      <div class="document-card" @click="openDocument('play_off.pdf')">
        <div class="document-icon">
          <i class="fas fa-image"></i>
        </div>
        <h3>Hrací plán Play-off</h3>
        <p>Struktura a pravidla play-off turnaje</p>
      </div>
      <!-- 
      <div class="document-card" @click="openDocument('pravidla.pdf')">
        <div class="document-icon">
          <i class="fas fa-file-pdf"></i>
        </div>
        <h3>Kompletní pravidla</h3>
        <p>Kompletní znění pravidel soutěže</p>
      </div>
      -->

      <div class="document-card" @click="openDocument('registrace_klubu.pdf')">
        <div class="document-icon">
          <i class="fas fa-file-pdf"></i>
        </div>
        <h3>Registrace klubu</h3>
        <p>Formulář pro registraci klubu</p>
      </div>
      <div class="document-card" @click="downloadSamplePlayersCsv">
        <div class="document-icon">
          <i class="fas fa-file-pdf"></i>
        </div>
        <h3>Registrace hráčů</h3>
        <p>Vzorový soubor pro soupisky tymů v CSV</p>
      </div>
      <div class="document-card" @click="openDocument('zapis_utkani.pdf')">
        <div class="document-icon">
          <i class="fas fa-file-pdf"></i>
        </div>
        <h3>Zápis o utkání</h3>
        <p>Formulář pro zápis z utkání</p>
      </div>
      <div class="document-card" @click="openDocument('prestup_form.pdf')">
        <div class="document-icon">
          <i class="fas fa-file-pdf"></i>
        </div>
        <h3>Přestup hráče</h3>
        <p>Formulář pro přestup hráče</p>
      </div>
      <div class="document-card" @click="openDocument('hostovani.pdf')">
        <div class="document-icon">
          <i class="fas fa-file-pdf"></i>
        </div>
        <h3>Hostování</h3>
        <p>Formulář pro hostování</p>
      </div>
      <div class="document-card" @click="openDocument('souhlas_mladi.pdf')">
        <div class="document-icon">
          <i class="fas fa-file-pdf"></i>
        </div>
        <h3>Souhlas zákonného zástupce</h3>
        <p>Formulář pro udělení souhlasu zákonného zástupce ke hraní v soutěži</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'DocumentsPage',
  methods: {
    openDocument(filename) {
      if (filename.endsWith('.pdf')) {
        window.open(`/${filename}`, '_blank');
      } else {
        window.open(`/documents/${filename}`, '_blank');
      }
    },
    downloadSamplePlayersCsv() {
      const csv = `jméno,příjmení,číslo_dresu,pozice,registrovaný\nJan,Novák,10,Útočník,true\nPetr,Svoboda,22,Obránce,false\nKarel,Malý,1,Brankář,true\n`;
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'example_players.csv';
      a.click();
      URL.revokeObjectURL(url);
    }
  }
}
</script>

<style scoped>
.documents-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem 3rem;
  background: #0a1023;
  color: #e0e6f7;
  min-height: 100vh;
}

h2 {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  font-size: 1.75rem;
  margin-bottom: 2rem;
  text-align: center;
}

.documents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
}

.document-card {
  background: #151d3a;
  border: 1px solid rgba(31, 224, 255, 0.08);
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.document-card:hover {
  transform: translateY(-4px);
  border-color: rgba(31, 224, 255, 0.2);
  box-shadow: 0 8px 24px rgba(10, 16, 35, 0.4),
              0 0 0 1px rgba(31, 224, 255, 0.05);
}

.document-icon {
  font-size: 3rem;
  color: #1fe0ff;
  margin-bottom: 1rem;
}

.document-card h3 {
  color: #e0e6f7;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
  font-weight: 700;
}

.document-card p {
  color: #8892b0;
  font-size: 0.95rem;
}
</style> 